import React from "react";

import { ApplicationOverview } from "../../layouts/applicationOverview/ApplicationOverview";

const ApplicationOverviewSitecore = (props) => <ApplicationOverview fields={props.fields} />;

export default ApplicationOverviewSitecore;
